import api from '@/services/api/static.js'

const SHELL_HOSTED = process.env.REACT_APP_SHELL_HOSTED === 'true'

const setStaticDataAction = (data) => {
    return {
        type: 'staticData/set',
        payload: {
            data: data,
            initialized: true,
        }
    }
}

const removeStaticDataAction = () => {
    sessionStorage.removeItem('orgsys')
    return {
        type: 'staticData/remove',
    }
}

const setStaticData = () => {
    return async (dispatch) => {
        // Cache-first (shell only): portal pre-fetches orgsys at login. Reuse
        // the cached value instead of refetching on every pitstop-ui boot (once
        // per cross-app entry under SHELL_HOSTED), keeping the sub-app's org data
        // consistent with the same snapshot the portal used to build the nav.
        // Legacy (standalone) keeps refetching fresh on every mount — exactly
        // main's behaviour — since there's no portal nav to stay consistent with.
        const cached = SHELL_HOSTED ? sessionStorage.getItem('orgsys') : null
        if (cached) {
            try {
                dispatch(setStaticDataAction(JSON.parse(cached)))
                return
            } catch (_) { /* corrupted cache — fall through to API */ }
        }

        // Fallback: legacy URL flow (no portal pre-fetch) or rare cache-clear edge.
        const [error, data] = await api.index()
        if (error) {
            console.error('failed to request static data')
            return
        }
		try {
			sessionStorage.setItem('orgsys', JSON.stringify(data));
		} catch (e) {
			console.warn('failed to save static data to session storage')
		}
        dispatch(setStaticDataAction(data))
    }
}

export default {
    setStaticData,
    removeStaticDataAction,
}
